export default __webpack_public_path__ + "static/media/fxClick.14e243bc.mp3";